export default "__VITE_ASSET__Bl_wgeNH__"